import React, { useState, useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import ProductList from '../components/ProductList.tsx';
import CanvaTopBar from '../components/CanvaTopBar.tsx';
import CanvaHelpFab from '../components/CanvaHelpFab.tsx';
import { useCanvaAuth } from '../contexts/CanvaAuthContext2.tsx';
import GiftModal from '../components/GiftModal.tsx';

const CanvaPurchase = () => {
  const { canvaAuthenticated } = useCanvaAuth();
  const location = useLocation();
  const isUpgrade = location.pathname.includes("upgrade");
  const [showGiftModal, setShowGiftModal] = useState(false);
  const [billingPeriod, setBillingPeriod] = useState<'monthly' | 'annual'>('monthly');
  const isPricingTest = canvaAuthenticated?.userProfile?.pricingTest === true;

  useEffect(() => {
    const p = canvaAuthenticated?.userProfile;
    const hasGift = !!p?.gift;
    const surveyRaw =
      p?.giftSurveyOptions ?? p?.gift_survey_options ?? p?.giftSurvey;
    const hasSurvey = Array.isArray(surveyRaw) && surveyRaw.length > 0;
    if (hasGift || hasSurvey) {
      setShowGiftModal(true);
    }
  }, [canvaAuthenticated]);

  // Track ViewContent event for Meta Pixel when pricing page loads
  useEffect(() => {
    if (canvaAuthenticated && typeof window !== 'undefined' && (window as any).fbq) {
      (window as any).fbq('track', 'ViewContent', {
        content_name: 'Pricing Page',
        content_category: 'Pricing'
      });
    }
  }, [canvaAuthenticated]);

  return (
    <>
      <Helmet>
        <title>AI Music by Muzaic</title>
      </Helmet>
      
      {canvaAuthenticated && (
        <div className="canva-purchase-page">
          <CanvaTopBar />

          <main className="canva-purchase-main">
            <div className="canva-purchase-hero pt-4 pt-lg-5 pb-3">
              <h1 className="canva-purchase-title text-center mb-4 mb-lg-5 px-2">
                <span className="canva-purchase-title-accent">
                  {isUpgrade
                    ? canvaAuthenticated.env.strings['app-product-list-title-test-upgrade'] ||
                      'app-product-list-title-test-upgrade'
                    : canvaAuthenticated.env.strings['app-product-list-title-test-manage'] ||
                      'app-product-list-title-test-manage'}
                </span>
              </h1>

              {isPricingTest && (
                <div className="canva-purchase-billing text-center d-flex justify-content-center align-items-center flex-wrap gap-2 mb-4">
                  <div className="billing-label-container">
                    <span
                      className={`canva-purchase-billing-label ${billingPeriod === 'monthly' ? 'fw-semibold' : ''}`}
                    >
                      {canvaAuthenticated.env.strings['app-product-list-billing-monthly'] ||
                        'app-product-list-billing-monthly'}
                    </span>
                  </div>
                  <Form.Check
                    type="switch"
                    id="billing-period-switch"
                    checked={billingPeriod === 'annual'}
                    onChange={(e) => setBillingPeriod(e.target.checked ? 'annual' : 'monthly')}
                    className="custom-switch canva-purchase-billing-switch"
                  />
                  <div className="billing-label-container">
                    <span
                      className={`canva-purchase-billing-label ${billingPeriod === 'annual' ? 'fw-semibold' : ''}`}
                    >
                      {canvaAuthenticated.env.strings['app-product-list-billing-annual'] ||
                        'app-product-list-billing-annual'}
                    </span>
                  </div>
                </div>
              )}
            </div>

            <div className="container-wide px-3 px-md-4 px-lg-4 pb-5">
              <ProductList billingPeriod={billingPeriod} />
            </div>

            <footer className="canva-purchase-footer text-center pb-5 px-3">
              © Muzaic {new Date().getFullYear()}
              <br />
              <a
                className="canva-purchase-footer-link"
                href="https://muzaic.ai/terms-of-use"
                target="_blank"
                rel="noopener noreferrer"
              >
                {canvaAuthenticated.env.strings['app-link-terms-of-use'] || 'app-link-terms-of-use'}
              </a>
            </footer>
          </main>

          <CanvaHelpFab />
        </div>
      )}
      
      <GiftModal show={showGiftModal} onClose={() => setShowGiftModal(false)} />

      
    </>
  );
};

export default CanvaPurchase;
